<template>
  <div class="container" >
      
        <div class="div-top">
            <div class="div-search-box">
                <img class="img-search" src="/images/ic_search.png"/> 
                <input v-model="searchText" v-on:keyup="searchChat" type="text" class="input-search" placeholder="ค้นหา" />
            </div>
            <!-- <br /> -->
            
        </div>

        <div class="div-center">
            <a :href="'/chat/'+session.session_id" v-for="session in sessions" :key="session.key" >
                <div class="div-chat-list-item">
                    <img v-if="userType == 'F'" class="img-fortune" :src="session.customer_image" />
                    <img v-if="userType == 'C'" class="img-fortune" :src="session.fortune_image" />
                    <div class="div-container-message">
                        <label class="label-fortune-name" v-if="userType == 'C'">
                            {{session.fortune_name}}
                        </label>
                        <label class="label-fortune-name" v-if="userType == 'F'">
                            {{session.customer_name}}
                        </label>
                        <label class="label-last-message">
                            {{session.last_message}}
                        </label>
                    </div>
                    <div class="div-container-date">
                        <label class="label-updated-date">
                            {{formatDate(session.last_access)}}
                        </label>
                        <div class="div-unread-count" v-if="session.unread_count > 0">
                            <label class="label-unread-count">
                                {{session.unread_count}}
                            </label>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import router from '../router'
import firebase from '../Firebase'
import moment from 'moment'
import axios from 'axios'
import "@/assets/chatlist.css"
import { mapActions, mapState, mapGetters } from "vuex"
export default {
  name: 'Main',
  data() {
    return {
        sessions:[],
        token: this.$route.query.token,
        loading: true,
        session_data: {
            fortune_name: "",
            fortune_image: "",
        },
        currentUser: null,
        searchText: "",
        last_message_id: null
    }
  },
  props: {
    msg: String
  },
  computed: {
    ...mapGetters({
      userType: "user/getUserType",
      userId: "user/getUserId",
    }),
  },
  methods: {
    getUserType: function() {
      return this.userType;
    },
    getUserId: function() {
      return this.userId;
    },
    async searchChat(){
        var _this = this
        if(this.searchText == '' || this.searchText.length >= 3){
            
            let sessions = await this.listSession()
            
            if(sessions != null){
                this.sessions = [];
                for(var i in sessions){
                    const session_id = sessions[i]
                    let session = await _this.findSessionData(session_id)
                    //console.log(this.searchText, session)
                    var found = false
                    if(this.userType == 'F'){
                        if(session.customer_name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1){
                            found = true
                        }
                    }else if(this.userType == 'C'){
                        if(session.fortune_name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1){
                            found = true
                        }
                    }
                    //console.log(this.searchText, found)
                    let last_message = ''
                    let found_message = null
                    let unreadCount = 0
                    if(session.chats != null){
                        for(var i in session.chats){
                            const chat = session.chats[i]
                            last_message = chat.message
                            if(this.userType == 'F'){
                                if(chat.fortune_read == 'N'){
                                    unreadCount = unreadCount + 1
                                }
                            }else if(this.userType == 'C'){
                                if(chat.customer_read == 'N'){
                                    unreadCount = unreadCount + 1
                                }
                            }
                            if(chat.message.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1){
                                found = true
                                found_message = chat.message
                            }
                        }
                    }
                    if(found){
                        var isIn = false
                        for(var j in this.sessions){
                            if(this.sessions[j].session_id == session_id)
                                isIn = true
                        }
                        if(!isIn){
                            this.sessions.push({
                                customer_id: session.customer_id,
                                customer_image: session.customer_image,
                                customer_name: session.customer_name,
                                fortune_id: session.fortune_id,
                                fortune_image: session.fortune_image,
                                fortune_name: session.fortune_name,
                                last_access: session.last_access,
                                schedule_id: session.schedule_id,
                                session_id: session.session_id,
                                last_message: found_message != null ? found_message : last_message,
                                unread_count: unreadCount
                            })
                        }
                    }
                }
            }
        }
    },
    async listSession() {
        const uid = await this.getUserId()
        var _this = this
        
        return new Promise((resolve, reject) => {
            firebase.database().ref('users/' + uid + '/sessions').on('value', (snapshot) => {
                var sessions = [];
                snapshot.forEach((doc) => {
                    let item = doc.val()
                    sessions.push(item)
                })
                resolve(sessions)
                
            });
        })
    },
    async incommingList(){
        var _this = this
        const uid = await this.getUserId()
        firebase.database().ref(`incoming`).limitToLast(1).on('value', async (doc) => {
            let item = doc.val()
            console.log('incommingList', item)  
            if(item != null){
                for(var i in item){
                    var inc = item[i]  
                    console.log('incommingList inc', inc.incoming_time, _this.last_message_id)
                    if(_this.last_message_id != null && inc.incoming_time > _this.last_message_id){
                        console.log('incommingList inc', inc)
                        _this.loadSession()
                        _this.last_message_id = inc.incoming_time
                    }
                }
            }                      
//             if(item.incoming_time > _this.last_message_id){
// console.log('incommingList', item)
//             }
        })

        // var commentsRef = firebase.database().ref('sessions/');
        // commentsRef.on('child_added', (data) => {
        //     //addCommentElement(postElement, data.key, data.val().text, data.val().author);
        //     console.log(data)
        // });
    },
    async loadSession() {
        var _this = this
        const uid = await this.getUserId()
        console.log('================================== start load session : ', uid)
        let sessions = await this.listSession()
        if(sessions && sessions.length > 0){
            this.sessions = []

            for(var session_id of sessions){
                console.log('session ===> ', session_id)

                let session = await _this.findSessionData(session_id)
                console.log('load session : ', session_id, session)

                if(session.no_message != null && session.no_message == 'N'){
                    let last_message = ''
                    let unreadCount = 0
                    if(session.chats != null){
                        for(var i in session.chats){
                            const chat = session.chats[i]
                            last_message = chat.message
                            if(chat.type == 'image'){
                                last_message = 'รูปภาพ'
                            }
                            if(this.userType == 'F'){
                                if(chat.fortune_read == 'N'){
                                    unreadCount = unreadCount + 1
                                }
                            }else if(this.userType == 'C'){
                                if(chat.customer_read == 'N'){
                                    unreadCount = unreadCount + 1
                                }
                            }
                            this.last_message_id = chat.message_id
                            console.log('unreadCount ::: ',unreadCount)
                        }
                    }
                    
                    this.sessions.push({
                        customer_id: session.customer_id,
                        customer_image: session.customer_image,
                        customer_name: session.customer_name,
                        fortune_id: session.fortune_id,
                        fortune_image: session.fortune_image,
                        fortune_name: session.fortune_name,
                        last_access: session.last_access,
                        schedule_id: session.schedule_id,
                        session_id: session.session_id,
                        last_message: last_message,
                        unread_count: unreadCount
                    })
                }
            }
        }
        // firebase.database().ref('users/' + uid + '/sessions').on('value', (snapshot) => {
        //     this.sessions = [];
        //     console.log('load session from firebase : ', snapshot)
        //     snapshot.forEach(async (doc) => {
        //         let item = doc.val()
        //         console.log('load session : ', item)
        //         let session = await _this.findSessionData(item)
        //         console.log('load session : ', item, session)

        //         let last_message = ''
        //         let unreadCount = 0
        //         if(session.chats != null){
        //             for(var i in session.chats){
        //                 const chat = session.chats[i]
        //                 last_message = chat.message
        //                 if(chat.type == 'image'){
        //                     last_message = 'รูปภาพ'
        //                 }
        //                 if(this.userType == 'F'){
        //                     if(chat.fortune_read == 'N'){
        //                         unreadCount = unreadCount + 1
        //                     }
        //                 }else if(this.userType == 'C'){
        //                     if(chat.customer_read == 'N'){
        //                         unreadCount = unreadCount + 1
        //                     }
        //                 }
        //                 this.last_message_id = chat.message_id
        //                 console.log('unreadCount ::: ',unreadCount)
        //             }
        //         }
                
        //         this.sessions.push({
        //             customer_id: session.customer_id,
        //             customer_image: session.customer_image,
        //             customer_name: session.customer_name,
        //             fortune_id: session.fortune_id,
        //             fortune_image: session.fortune_image,
        //             fortune_name: session.fortune_name,
        //             last_access: session.last_access,
        //             schedule_id: session.schedule_id,
        //             session_id: session.session_id,
        //             last_message: last_message,
        //             unread_count: unreadCount
        //         })
        //         // if(session.no_message || session.no_message == 'N'){
        //         // }
        //     });
            
        // });
    },
    async findSessionData(session_id) {
        return new Promise((resolve, reject) => {
            var db = firebase.database();
            var ref = db.ref("/sessions/" + session_id);
            ref.once("value", function(snapshot) {
                //console.log('findSessionData', session_id, snapshot.val())
                if(snapshot.val() != null){
                    resolve(snapshot.val())
                }else{
                    resolve(null)
                }
            })
        })
    },
    formatDate(date){
        var dateString = ''
        const myMomentObject = moment(date, 'YYYY-MM-DD HH:mm:ss')
        const dateCrt = myMomentObject.format('YYYY-MM-DD')
        //console.log(date, dateCrt)
        if(moment().format('YYYY-MM-DD') == dateCrt){
            dateString = 'วันนี้ '+myMomentObject.format('HH:mm')
        }else if(moment().add(-1, 'days').format('YYYY-MM-DD') == dateCrt){
            dateString = 'เมื่อวานนี้ '+myMomentObject.format('HH:mm')
        }else{
            dateString = myMomentObject.add(543, 'years').format('DD/MM/YYYY')
        }
        return dateString
    },
    interim: function () {
        const self = this;          
        this.intervalid1 = setInterval(function(){
            if(this.userType == 'F'){
                let interimData = firebase.database().ref('connection/'+self.userId)
                interimData.set({
                    connect_time: moment().valueOf()
                });
            }else{
                let interimData = firebase.database().ref('connection/'+self.userId)
                interimData.set({
                    connect_time: moment().valueOf()
                });
            }
            
        }, 10000);
    }
  },
  async created() {
    //console.log('created : ')
  },
  async mounted() {
    console.log('mounted : ')
    const uid = await this.getUserId()
    console.log('uid ::: ', uid)
    if(uid != null){
        this.loading = false
        
        await this.loadSession()
        
        await this.incommingList()
        this.interim()
    }else{
        router.push(`/error`) 
    }
    //console.log('uid : ', uid)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>
